import { render, staticRenderFns } from "./WebsiteData.vue?vue&type=template&id=20a12ad7&scoped=true&"
import script from "./WebsiteData.vue?vue&type=script&lang=js&"
export * from "./WebsiteData.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/form.css?vue&type=style&index=0&id=20a12ad7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a12ad7",
  null
  
)

export default component.exports